<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
    <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Derivar Fichas"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          submitCheckbox: true,
          class: "btn btn-xs btn-info pull-right",
          route: this.$root.UrlBase(
            "registros/acciones/derivar-fichas/derivacion"
          ),
          text: "Derivar",
          name: "sel",
          description: '<i class="fa fa-plus">',
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        sel: "",
        vencimiento: "",
        creacion: "",
        f___nodo_numer: "",
        f___nro_ficha: "",
        f___descripcion: "",
        t___descripcion: "",
        e___descripcion: "",
        usuario_anterior: "",
        z___razon: "",
      },
      busquedaTraduccion: {
        sel: this.$root.trans("Sel."),
        vencimiento: this.$root.trans("Vencim."),
        creacion: this.$root.trans("Creación"),
        f___nodo_numer: this.$root.trans("Código"),
        f___nro_ficha: this.$root.trans("Ficha"),
        f___descripcion: this.$root.trans("Descripción"),
        t___descripcion: this.$root.trans("Tipo de NC"),
        e___descripcion: this.$root.trans("Etapa Actual"),
        usuario_anterior: this.$root.trans("Usuario anterior"),
        z___razon: this.$root.trans("Sujeto"),
      },
      busquedaCampos: {
        usuario_anterior: {
          type: "select",
          options: [],
        },
        vencimiento: {
          type: "date",
        },
        creacion: {
          type: "date",
        },
        sel: {
          type: "checkbox",
        },
      },
      busquedaMedidas: {
        sel: "60px",
        vencimiento: "160px",
        creacion: "160px",
        f___nodo_numer: "90px",
        f___nro_ficha: "160px",
        f___descripcion: "180px",
        t___descripcion: "160px",
        e___descripcion: "160px",
        usuario_anterior: "160px",
        z___razon: "160px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        User: {},
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.usuario_anterior.options = response.User;
      });
  },
};
</script>
